import { render, staticRenderFns } from "./add-site-button.vue?vue&type=template&id=1bdd7da0&"
import script from "./add-site-button.vue?vue&type=script&lang=js&"
export * from "./add-site-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports